export default (theme) => ({
  circleLoader: {
    color: theme.colorPalette.white_10
  }
});
